import styled from 'styled-components';

export const SkeletonWrapper = styled.div`
  min-height: 112px;
  display: flex;
  flex-direction: row;
  max-width: ${Styles.layout.sectionMaxWidth};
  width: 100%;
  padding: 1rem;
  gap: 1rem;
`;

export const SkeletonTextWrapper = styled.div`
  width: 70%;
`;

export const SkeletonButtonWrapper = styled.div`
  height: 35px;
  width: 30%;
  color: ${Styles.color.primary};
  & span span {
    border-radius: 99rem;
  }
`;
